import * as React from 'react';
import {Empty} from "antd";
import {useTranslation} from "react-i18next";

interface NoDataInterface {
    description?: string;
    image?:React.ReactNode;
}

const NoData:React.FC<NoDataInterface> = (props) => {
    const {t} = useTranslation();
    return (
        <Empty
            image={props.image !== undefined? props.image : Empty.PRESENTED_IMAGE_SIMPLE}
            description={props.description !== undefined ? props.description : t('noData')}
        />
    )
}
export default NoData;